<template>
    <v-card
        class="dashboard-card ma-2"
        elevation="4"
    >
        <v-card-title>Management Area Representative</v-card-title>
        <v-card-subtitle>number of incidents(/patients), by days ago</v-card-subtitle>

        <!--#region-=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-new incidents--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">New Incidents</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsNew: true,
                                agedDaysMax: 1,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-1</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.newIncidents.group1 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsNew: true,
                                agedDaysMin: 2,
                                agedDaysMax: 2,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">2</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.newIncidents.group2 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsNew: true,
                                agedDaysMin: 3,
                                agedDaysMax: 3,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">3</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.newIncidents.group3 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsNew: true,
                                agedDaysMin: 4,
                                agedDaysMax: 4,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">4</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.newIncidents.group4 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsNew: true,
                                agedDaysMin: 5,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">5+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.newIncidents.group5_Plus }}</h3>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->

        <!--#region-=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-registered incidents--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Registered Incidents</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsRegistered: true,
                                agedDaysMax: 1,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat ageing-stat-wide"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-1</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.registeredIncdients.group1 }} / {{ dataObject.registeredIncdientsPatients.group1 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsRegistered: true,
                                agedDaysMin: 2,
                                agedDaysMax: 2,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat ageing-stat-wide"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">2</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.registeredIncdients.group2 }} / {{ dataObject.registeredIncdientsPatients.group2 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsRegistered: true,
                                agedDaysMin: 3,
                                agedDaysMax: 3,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat ageing-stat-wide"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">3</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.registeredIncdients.group3 }} / {{ dataObject.registeredIncdientsPatients.group3 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsRegistered: true,
                                agedDaysMin: 4,
                                agedDaysMax: 4,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat ageing-stat-wide"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">4</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.registeredIncdients.group4 }} / {{ dataObject.registeredIncdientsPatients.group4 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsRegistered: true,
                                agedDaysMin: 5,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat ageing-stat-wide"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">5+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.registeredIncdients.group5_Plus }} / {{ dataObject.registeredIncdientsPatients.group5_Plus }}</h3>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->
        
        <!--#region-=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-suspended incidents--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Suspended Incidents</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsSuspended: true,
                                agedDaysMax: 1,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-1</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.suspendedIncidents.group1}}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsSuspended: true,
                                agedDaysMin: 2,
                                agedDaysMax: 2,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">2</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.suspendedIncidents.group2}}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsSuspended: true,
                                agedDaysMin: 3,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">3+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.suspendedIncidents.group3_Plus}}</h3>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->
        
        <!--#region-=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-FRAUDULENT-INCIDENT--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Fraudulent Incidents</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsFraudulent: true,
                                agedDaysMax: 1,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">0-1</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.fraudulent.group1 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsFraudulent: true,
                                agedDaysMin: 2,
                                agedDaysMax: 2,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">2</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.fraudulent.group2 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsFraudulent: true,
                                agedDaysMin: 3,
                                agedDaysMax: 3,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">3</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.fraudulent.group3 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsFraudulent: true,
                                agedDaysMin: 4,
                                agedDaysMax: 4,                                
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">4</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.fraudulent.group4 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsFraudulent: true,
                                agedDaysMin: 5,                                
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">5+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.fraudulent.group5_Plus }}</h3>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->
        
        <!--#region-=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-completed incidents--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Complete Incidents</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsComplete: true,
                                agedDaysMax: 1,                                
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">0-1</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.completed.group1 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsComplete: true,
                                agedDaysMin: 2,
                                agedDaysMax: 2,                                
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">2</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.completed.group2 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsComplete: true,
                                agedDaysMin: 3,
                                agedDaysMax: 3,                                
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">3</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.completed.group3 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsComplete: true,
                                agedDaysMin: 4,
                                agedDaysMax: 4,                                
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">4</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.completed.group4 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsComplete: true,
                                agedDaysMin: 5,                                
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">5+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.completed.group5_Plus }}</h3>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->
        
        <!--#region-=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-finalised incidents--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Finalised Incidents</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsFinalised: true,
                                agedDaysMax: 7,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-green darken-2 white--text text-center"
                    dark
                >
                    <span class="header">0-7</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.finalised.group0_7 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsFinalised: true,
                                agedDaysMin: 8,
                                agedDaysMax: 15,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-green darken-2 white--text text-center"
                    dark
                >
                    <span class="header">8-15</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.finalised.group8_15 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsFinalised: true,
                                agedDaysMin: 16,
                                agedDaysMax: 23,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-green darken-2 white--text text-center"
                    dark
                >
                    <span class="header">16-23</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.finalised.group16_23 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsFinalised: true,
                                agedDaysMin: 24,
                                agedDaysMax: 31,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-green darken-2 white--text text-center"
                    dark
                >
                    <span class="header">24-31</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.finalised.group24_31 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                marIsFinalised: true,
                                agedDaysMin: 32,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-green darken-2 white--text text-center"
                    dark
                >
                    <span class="header">32+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.finalised.group32_Plus }}</h3>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->
        
        <!--#region-=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-FOOTER--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <v-row justify="end">
                <v-col
                    align-self="center"
                    cols="12"
                    md="6"
                >
                    <h5
                        class="text--secondary"
                        style="text-align: right"
                    >
                        Auto updates every
                        {{ (refreshSeconds / 60000).toString().substr(0, 4) }} minutes
                        or
                        <v-btn
                            @click="getData"
                            class="ml-1 white--text"
                            color="secondary darken-1"
                            elevation="4"
                            fab
                            x-small
                        >
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </h5>
                </v-col>
            </v-row>
        </v-card-text>
        <!--#endregion-->
    </v-card>
</template>

<script>
export default {
    name: "ManagementAreaRepresentativeWidget",
    props: {
        selectedAreaProviderFilter: {
            type: Object,
            default: () => {
                return { areaId: 0, providerId: 0 };
            }
        }
    },
    data: () => ({
        dataObject: null,
        refreshTimeout: null,
        refreshSeconds: 300000,
        storeDispatch: "incidents/getmanagementarearepresentativewidget",
        providerId: 0,
        areaId: 0,
        //
    }),
    mounted: function() {
        this.refreshTimeout = setTimeout(this.getData, 0);
    },
    computed: {
        //
    },
    watch: {
        selectedAreaProviderFilter: function() {
            this.providerId = this.selectedAreaProviderFilter.providerId;
            this.areaId = this.selectedAreaProviderFilter.areaId;
            this.getData();
        }
    },
    methods: {
        getData() {
            this.stopRefreshTimeOut();
            this.dataObject = null;

            this.$store
                .dispatch(this.storeDispatch, {
                    urlParameters: {
                        providerId: this.selectedAreaProviderFilter.providerId,
                        areaId: this.selectedAreaProviderFilter.areaId
                    }
                })
                .then(dataResponse => {
                    this.dataObject = dataResponse;
                })
                .finally(() => {
                    this.refreshTimeout = setTimeout(
                        this.getData,
                        this.refreshSeconds
                    );
                });
        },
        stopRefreshTimeOut() {
            if (this.refreshTimeout != null) clearTimeout(this.refreshTimeout);
        }
        //--------------------
    },
    destroyed: function() {
        this.stopRefreshTimeOut();
    }
};
</script>

<style lang="stylus" scoped>
span {
    .facevalue {
        font-size: 0.54rem;
    }
}

#app.theme--light {
    span.facevalue {
        color: black !important;
    }
}

#app.theme--dark {
    span.facevalue {
        color: white !important;
    }
}
</style>